import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { first } from 'rxjs/operators';
import { version } from '../app.version';
import { LoaderService, SessionService, TimeSheetVisibilityService } from '../core';
import { PilotPayVersionService } from './pilotpay-version.service';
import { IPilotPayVersion } from './pilotpay-version.types';
import { Location } from '@angular/common';
import { SwUpdate } from '@angular/service-worker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PilotPayAuthResponseOptions } from '../types/auth.type';

@Component({
	styleUrls: ['./pilotpay.component.scss'],
	templateUrl: './pilotpay.component.html'
})
export class PilotpayComponent implements OnInit, OnDestroy {
	constructor(
		public router: Router,
		public pilotPayVersionService: PilotPayVersionService,
		public sessionService: SessionService,
		public loaderService: LoaderService,
		public changeDetector: ChangeDetectorRef,
		public loc: Location,
		private swUpdate: SwUpdate,
		private snackbar: MatSnackBar,
		private timeSheetVisibilityService: TimeSheetVisibilityService
	) {
		this.swUpdate.available.subscribe(() => {
			const snack: any = this.snackbar.open(`Updates Available`, 'Reload');

			snack.onAction().subscribe(() => {
				window.location.reload();
			});

			snack.setTimeout(() => {
				snack.dismiss();
			}, 6000);
		});
	}

	public hideOverflow: boolean = false;
	public url: string;
	public isLogined: boolean = false;
	public clientBuild: number = version.buildNumber;
	public serverBuild: number = -1;
	public isConnected: boolean;
	public utcDate: string;
	public config: PerfectScrollbarConfigInterface = {};
	public isAdmin: boolean = false;
	public displayName: string = '';
	public payScaleId: number;
	public employeeId: number;

	// tslint:disable-next-line: no-any
	private intervalHolder: any;

	public ngOnInit(): void {
		this.isConnected = navigator.onLine;
		this.getConnectionStatus();
		this.utcDate = moment
			.utc()
			.toDate()
			.toUTCString();
		this.getRequestServerBuildNumber();
		this.getUserDetails();
		this.intervalHolder = setInterval(() => {
			this.utcDate = moment
				.utc()
				.toDate()
				.toUTCString();
			if (this.changeDetector !== null && this.changeDetector !== undefined) {
				this.changeDetector.detectChanges();
			}
		}, 1000);
		this.timeSheetVisibilityService.getTimeSheetMobileVisibility().subscribe(v => (this.hideOverflow = v));
	}

	public ngOnDestroy(): void {
		clearInterval(this.intervalHolder);
	}

	public getUserDetails(): void {
		const user: PilotPayAuthResponseOptions = this.sessionService.getUser();

		this.isAdmin = user.isAdmin;
		this.displayName = user.displayName;
		this.payScaleId = user.payScaleId;
		this.employeeId = user.employeeId;
	}

	public logout(): void {
		this.isLogined = false;
		this.loaderService.setLoadingStatus(true);
		this.router
			.navigate(['./logout'])
			.then(() => {
				this.isLogined = false;
				this.loaderService.setLoadingStatus();
			})
			.catch((err: Error) => {
				console.error(err);
			});
	}

	private getRequestServerBuildNumber(): void {
		this.pilotPayVersionService
			.getServerBuildVersion()
			.pipe(first())
			.subscribe((response: IPilotPayVersion) => (this.serverBuild = response.build));
	}

	private getConnectionStatus(): void {
		window.addEventListener('online', () => {
			this.isConnected = true;
			this.router.navigateByUrl(this.loc.path(true));
		});
		window.addEventListener('offline', () => {
			this.isConnected = false;
			this.router.navigate(['./pilotpay/offline'], { skipLocationChange: true });
		});
	}
}
